import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomAutoMultiSelect from "../commoncomponents/CustomAutoMultiSelect";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import {
  getAuthToken,
  getuserId,
} from "../../utility/tokenUtility";
import { MasterGraph } from "../../utility/apiURLS";
import axios from "axios";
import CustomTextField from "../commoncomponents/CustomTextField";
import utilities from "../../utility/utilities";
import { dialogContent, validations } from "../../utility/message";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomDialog from "../commoncomponents/CustomDialog";

const CreateModal = ({ handleModalCancel, dutyOptions = [], shiftOptions = [], fetch }) => {
  const currentDate = utilities.getCurrentDateFormatted("DD/MM/YYYY");
  const token = getAuthToken("id_token");
  const facilityId = getAuthToken("facilityId");
  const [employeesOptions, setEmployeesOptions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [shift, setShift] = useState("");
  const [duty, setDuty] = useState("");
  const [fromDate, setFromDate] = useState(currentDate);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [toDate, setToDate] = useState("");
  const [desc, setDesc] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [errorMessages, setErrorMessages] = useState({});
  const [errors, setErrors] = useState({});
  const [contentDialog, setContentDialog] = useState("")
  const [openDialog, setOpenDialog] = useState(false)
  const [openValidationDialog, setOpenValidationDialog] = useState(false)
  const [isAddNew, setIsAddNew] = useState(false)
  const [isChanged, setIsChanged] = useState(false)
  const [enableSubmit, setEnableSubmit] = useState(true)
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];

  const handleEmployeesChange = (newValue) => {
    setIsChanged(true)
    if (newValue.length > 0) {
      setErrors((prev) => ({ ...prev, employees: false }));
      setErrorMessages((prev) => ({ ...prev, employees: "" }));
    }
    setEmployees(newValue);
  };

  const handleServiceChange = (event) => {
    const { value, checked } = event.target;
    setSelectedServices((prev) =>
      checked ? [...prev, value] : prev.filter((service) => service !== value)
    );
  };

  const checkInclusion = (arr) => {
    const hasFEMS = arr.includes("FEMS");
    const hasBEMS = arr.includes("BEMS");

    if (hasFEMS && hasBEMS) {
      return 2; // Both included
    } else if (hasFEMS) {
      return 0; // FEMS only
    } else if (hasBEMS) {
      return 1; // BEMS only
    } else {
      return 3; // Neither included
    }
  };

  useEffect(() => {
    const value = checkInclusion(selectedServices)
    fetchEmployeesOptions(value)
  }, [selectedServices])


  const fetchEmployeesOptions = async (value) => {
    try {
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };

      let url

      switch (value) {
        case 0:
          url = `${MasterGraph}/api/GraphMasemployeedetails/GetEmployeeDetailsByServiceList/${facilityId}?fems=FEMS`
          break;
        case 1:
          url = `${MasterGraph}/api/GraphMasemployeedetails/GetEmployeeDetailsByServiceList/${facilityId}?bems=BEMS`
          break;
        case 2:
          url = `${MasterGraph}/api/GraphMasemployeedetails/GetEmployeeDetailsByServiceList/${facilityId}?fems=FEMS&bems=BEMS`
          break;

        case 3:
          url = `${MasterGraph}/api/GraphMasemployeedetails/GetEmployeeDetailsByServiceList/${facilityId}`
          break;

        default:
          break;

      }
      const employeesResponse = await axios.get(url, config)
      setEmployeesOptions(
        employeesResponse.data.map((employee) => ({
          ...employee,
          id: employee?.id,
          label: `${employee?.empCode} - ${employee?.empName} `,
          value: employee?.empName,
        }))
      );
    } catch (error) { }
  };


  const handleAvailabilityChange = (newValue) => {
    setIsChanged(true)
    if (newValue) {
      setErrors((prev) => ({ ...prev, duty: false }));
      setErrorMessages((prev) => ({ ...prev, duty: "" }));
    }
    setDuty(newValue);
  };

  const handleShiftChange = (newValue) => {
    setIsChanged(true)
    if (newValue) {
      setErrors((prev) => ({ ...prev, shift: false }));
      setErrorMessages((prev) => ({ ...prev, shift: "" }));
    }
    setShift(newValue);
  };

  const handleFromDateChange = (newValue) => {
    setIsChanged(true)
    if (toDate) {
      const valid = utilities.compareDates(newValue, toDate)
      if (!valid) {
        setToDate("")
      }
    }
    if (newValue) {
      setErrors((prev) => ({ ...prev, fromDate: false }));
      setErrorMessages((prev) => ({ ...prev, fromDate: "" }));
    }
    setFromDate(newValue);
  };

  const handleToDateChange = (newValue) => {
    setIsChanged(true)
    if (newValue) {
      setErrors((prev) => ({ ...prev, toDate: false }));
      setErrorMessages((prev) => ({ ...prev, toDate: "" }));
    }
    setToDate(newValue);
  };

  const handleStartTimeChange = (newValue) => {
    setIsChanged(true)
    if (newValue) {
      setErrors((prev) => ({ ...prev, startTime: false }));
      setErrorMessages((prev) => ({ ...prev, startTime: "" }));
    }
    setStartTime(newValue);
  };

  const handleEndTimeChange = (newValue) => {
    setIsChanged(true)
    setEndTime(newValue);
    if (newValue) {
      setErrors((prev) => ({ ...prev, endTime: false }));
      setErrorMessages((prev) => ({ ...prev, endTime: "" }));
    }
  };

  const handleDescriptionChange = (newValue) => {
    setIsChanged(true)
    if (newValue) {
      setErrors((prev) => ({ ...prev, desc: false }));
      setErrorMessages((prev) => ({ ...prev, desc: "" }));
    }
    setDesc(newValue);
  };

  const handleSubmit = () => {
    const requiredFields = [
      { field: "employees", value: employees, message: "Employees is Required. Please Select atleast one from the followings" },
      { field: "fromDate", value: fromDate, message: "From Date is Required" },
      { field: "toDate", value: toDate, message: "To Date is Required" },
      { field: "shift", value: shift, message: "Shift is Required" },
      { field: "duty", value: duty, message: "Options is Required" },
      { field: "startTime", value: startTime, message: "Shift Start Time is Required" },
      { field: "endTime", value: endTime, message: "Shift End Time is Required" },
      { field: "desc", value: desc, message: "Shift/Rotation Description is Required" },
    ];

    let isValid = true;

    // Check required fields
    requiredFields.forEach(({ field, value, message }) => {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        isValid = false;
        setErrors(prev => ({ ...prev, [field]: true }));
        setErrorMessages(prev => ({ ...prev, [field]: message }));
      }
    });

    // If the form is valid, proceed with saving
    if (isValid) {
      // Assuming handleSave is the function to save data
      handleSave();
    }
  };

  // Helper function to parse DD/MM/YYYY to a Date object
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day); // Month is zero-based in JavaScript
  };

  // Helper function to format Date object as YYYY-MM-DD
  const formatDate = (date, dbFormat = true) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
    const day = String(date.getDate()).padStart(2, "0");
    return dbFormat ? `${year}-${month}-${day} ` : `${day}/${month}/${year} `;
  };

  function combineEmployeesAndShifts(employees, shifts) {
    return employees.flatMap(employee =>
      shifts.map(shift => ({
        ...shift,
        employeeid: employee.id
      }))
    );
  }


  const getDateAfter90Days = (inputDate) => {
    const startDate = parseDate(inputDate);
    startDate.setDate(startDate.getDate() + 89); // Add 89 days to include the current date
    return formatDate(startDate, false);
  };

  const maxDate = getDateAfter90Days(currentDate)

  const populateRecords = (fromDate, toDate) => {
    const records = [];
    const start = parseDate(fromDate);
    const end = parseDate(toDate);

    // Iterate from start date to end date inclusively
    while (start <= end) {
      const formattedStartDate = formatDate(start);

      // Create a new Date object for shiftstarttime and shiftendtime, including time
      const shiftStartTime = new Date(`${formattedStartDate} ${startTime}:00`);
      const shiftEndTime = new Date(`${formattedStartDate} ${endTime}:00`);

      // If shiftEndTime is earlier than shiftStartTime, move shiftEndTime to the next day
      if (shiftEndTime <= shiftStartTime) {
        shiftEndTime.setDate(shiftEndTime.getDate() + 1);
      }

      records.push({
        shiftstarttime: `${formattedStartDate} ${startTime}:00`,
        shiftendtime: `${formatDate(shiftEndTime)} ${endTime}:00`,
        shiftdesc: desc,
        masstaffshiftId: shift.id,
        masstaffavailabilityId: duty.id,
      });

      start.setDate(start.getDate() + 1); // Move to the next day
    }

    return records;
  };

  const handleSave = async () => {
    // onSave({ fromDate, toDate, shift, duty, startTime, endTime, desc });
    // handleModalCancel(false)();

    const postHeaderCommon = {
      startDate: utilities.formatDate({ dateString: fromDate, format: "YYYY-MM-DD" }),
      endDate: utilities.formatDate({ dateString: toDate, format: "YYYY-MM-DD" }),
    };

    const postDataHeader = employees.map((emp) => {
      return {
        masemployeedetailsId: emp.id,
        ...postHeaderCommon
      }
    })
    const postDataDetail = populateRecords(fromDate, toDate)

    const finalPostDataDetail = combineEmployeesAndShifts(employees, postDataDetail)

    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const postUrlHeader = `${MasterGraph}/api/masstaffdutyrosters`
      const postUrlDetails = `${MasterGraph}/api/masstaffdutyrosterdetails`
      const result = await axios({
        method: "post",
        url: postUrlHeader,
        data: postDataHeader,
        headers: config.headers,
      });
      if (result.status === 200) {
        const result = await axios({
          method: "post",
          url: postUrlDetails,
          data: finalPostDataDetail,
          headers: config.headers,
        });
        if (result.status === 200) {
          setContentDialog(dialogContent.saved);
          setIsChanged(false);
          setOpenValidationDialog(true);
          setEnableSubmit(false);
          fetch()
        }

      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 400) {
        setOpenValidationDialog(true);
        setContentDialog(error.response.data.detail || validations.default);
      }
    }


  };

  const handleDialogClose = () => {
    if (isChanged) {
      setOpenDialog(false);
    }
    if (isAddNew) {
      setIsAddNew(false);
    }
  };

  const handleDialogConfirm = () => {
    setOpenValidationDialog(false);
    setOpenDialog(false);
    if (isChanged && !openValidationDialog && !isAddNew) {
      handleModalCancel(false)()
    }
    if (isAddNew) {
      setDefault();
    }
  };
  const setDefault = () => {
    setStartTime("")
    setEndTime("")
    setEmployees([])
    setFromDate(currentDate)
    setToDate("")
    setDesc("")
    setDuty("")
    setShift("")
    setSelectedServices([])
    setIsAddNew(false)
    setIsChanged(false)
    setErrorMessages({})
    setErrors({})
    setEnableSubmit(true)
  }
  const handleAddNew = () => {
    if (isChanged) {
      setIsAddNew(true);
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
    } else {
      setDefault();
    }
  };

  const handleCancel = () => {
    if (!isChanged) {
      handleModalCancel(false)()
    } else {
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
    }
  };

  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
        <Stack>
          <Typography variant="title2">Create New Shift</Typography>
          <Typography mt={-1} variant="labelSm">Note: Please Choose Service to Filter Employees
            <Typography component={"span"} color={"error"}>*</Typography>
          </Typography>
        </Stack>
        <IconButton onClick={handleCancel}>
          <HighlightOffIcon />
        </IconButton>
      </Stack>

      <Stack direction={"row"} gap={2}>
        <Box width={"23%"}>
          <FormControl fullWidth error={true}>
            <Box>
              <Typography variant="labelSm">Service</Typography>
            </Box>
            <FormGroup row>
              {serviceOptions.map((service) => (
                <FormControlLabel
                  key={service.value}
                  control={
                    <Checkbox
                      error={true}
                      checked={selectedServices?.includes(service.value)}
                      onChange={handleServiceChange}
                      value={service.value}
                    />
                  }
                  label={service.label}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Box>
        <Box width={"50%"}>
          <CustomAutoMultiSelect
            modal={true}
            label={"Employees"}
            defaultValue={employees}
            options={employeesOptions}
            onChange={handleEmployeesChange}
            error={errors.employees}
            helperText={errorMessages.employees}
            isMandatoryField={true}
          />
        </Box>
      </Stack>
      <Stack direction={"row"} gap={2} justifyContent={"space-between"} mt={2}>
        <Box width={"25%"}>
          <CustomDatePicker
            modal={true}
            label={"From Date"}
            onDateChange={handleFromDateChange}
            value={fromDate}
            error={errors.fromDate}
            helperText={errorMessages.fromDate}
            isMandatoryField={true}
            minimumDate={currentDate}
            maxDate={maxDate}
          />
        </Box>
        <Box width={"25%"}>
          <CustomDatePicker
            modal={true}
            label={"To Date"}
            onDateChange={handleToDateChange}
            value={toDate}
            error={errors.toDate}
            helperText={errorMessages.toDate}
            isMandatoryField={true}
            minimumDate={fromDate}
            maxDate={maxDate}
          />
        </Box>
        <Box width={"25%"}>
          <CustomSelectInput
            modal={true}
            label={"Shift"}
            options={shiftOptions}
            onChange={handleShiftChange}
            value={shift}
            error={errors.shift}
            helperText={errorMessages.shift}
            isMandatoryField={true}
          />
        </Box>
        <Box width={"25%"}>
          <CustomSelectInput
            modal={true}
            label={"Options"}
            options={dutyOptions}
            onChange={handleAvailabilityChange}
            value={duty}
            error={errors.duty}
            helperText={errorMessages.duty}
            isMandatoryField={true}
          />
        </Box>
      </Stack>
      <Stack direction={"row"} gap={2} justifyContent={"space-between"} mt={2}>
        <Box width={"25%"}>
          <CustomTimePicker
            modal={true}
            label={"Shift Start Time"}
            onTimeChange={handleStartTimeChange}
            value={startTime}
            error={errors.startTime}
            helperText={errorMessages.startTime}
            isMandatoryField={true}
          />
        </Box>
        <Box width={"25%"}>
          <CustomTimePicker
            modal={true}
            label={"Shift End Time"}
            onTimeChange={handleEndTimeChange}
            value={endTime}
            error={errors.endTime}
            helperText={errorMessages.endTime}
            isMandatoryField={true}
          />
        </Box>
        <Box width={"50%"}>
          <CustomTextField
            modal={true}
            label={"Shift/Rotation Description"}
            onChange={handleDescriptionChange}
            value={desc}
            error={errors.desc}
            helperText={errorMessages.desc}
            isMandatoryField={true}
          />
        </Box>
      </Stack>
      <ActionButtons
        handleCancel={handleCancel}
        handleSubmit={(e) => handleSubmit(e)}
        handleAddNew={handleAddNew}
        enableSubmit={enableSubmit}
      />
      <CustomDialog
        cancelBtn={"No"}
        open={openDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Yes"}
      />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Ok"}
      />
    </>
  );
};

export default CreateModal;
